export const getBaseURL = () => {
	if (typeof window !== 'undefined') {
		if (window) {
			if (window.location) {
				if (window.location.href) {
					return window.location.href;
				}
			}
		}
	}
};
